import { createAxios } from 'ts/createAxios';
import {
  AbnormalityForm,
  WeightNoticeItem,
  WeightNoticeResponse,
} from 'types/notice';
import { API_ENDPOINTS } from 'util/endPoints';
import { handleError } from 'util/errorHandler';

export const createNotificationAbnormality = async (
  formData: AbnormalityForm,
  successCallback?: () => void,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  failedCallback?: (error: any) => void
) => {
  const endpoint = formData.targetIds
    ? API_ENDPOINTS.ABNORMALITY_WEIGHT
    : API_ENDPOINTS.SUBSTITUTE_ABNORMALITY_WEIGHT;
  try {
    await createAxios().post<AbnormalityForm>(endpoint, {
      ...formData,
      images: formData.images?.map((img) => img.base64),
    });

    successCallback?.();
  } catch (error) {
    handleError(error);
    failedCallback?.(error);
  }
};

export const getNotices = async (p?: {
  params: {
    page?: number;
    take?: number;
    targetDate?: string;
  };
  successCallback?: (data: WeightNoticeResponse | WeightNoticeItem[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  failedCallback?: (error: any) => void;
  finallyCallback?: () => void;
}) => {
  const { params, successCallback, failedCallback, finallyCallback } = p || {};

  try {
    const { data } = await createAxios().get<
      WeightNoticeResponse | WeightNoticeItem[]
    >(API_ENDPOINTS.NOTICES, {
      params,
    });

    successCallback?.(data);
  } catch (e) {
    handleError(e);
    failedCallback?.(e);
  } finally {
    finallyCallback?.();
  }
};
